var image_viewer_rtlignore_default = {
  "fontElementMap": "DUE6f",
  "imageContainer": "jpy5s",
  "expandContainer": "LCEaV",
  "expandIcon": "np26i",
  "pointer": "gwUOq",
  "imageWrapper": "YD7ZH",
  "imageRatio": "bUMKC",
  "image": "_6R4GG",
  "imageOverlay": "WQI4q",
  "imagePreload": "LHRIX",
  "imageHighres": "TO3tD",
  "onlyHighRes": "F-jdl",
  "image_loading": "WiJRP"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
